import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { animateScroll } from 'react-scroll'
import withMixpanel, { SCREEN_VIEW_GROUP_TRAPS } from 'utils/mixpanel'
import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose'

import * as mapModule from 'modules/map'
import * as trapModule from 'modules/trap'
import * as toastModule from 'modules/toast'
import * as userActions from 'actions/userActions'
import * as routeActions from 'actions/routeActions'

import { isEqual, getPaginationObject } from 'utils/misc'

export default compose(
  withMixpanel,
  connect(
    (state) => {
      return {
        user: idx(state, _ => _.user) || null,
        traps: idx(state, _ => _.traps.items),
        tableLoading: idx(state, _ => _.traps.loading),
        group: idx(state, _ => _.groups.selected) || {},
        organisation: idx(state, _ => _.organisation.selected),
      }
    },
    (dispatch) => {
      const actions = {
        ...mapModule,
        ...trapModule,
        ...toastModule,
        ...userActions,
        ...routeActions,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withStateHandlers(
    () => ({
      filters: {
        search: null,
        pagination: {
          offset: 0, limit: 8
        },
        loaded: true,
      }
    }),
    {
      onPageChange: state => (offset) => {
        return getPaginationObject(state, {offset}, false)
      },
      setPagination: state => ({ count }) => {
        return getPaginationObject(state, { count }, true)
      },
      setFilters: state => newFilters => ({
        ...state,
        filters: {
          ...state.filters,
          ...newFilters,
          loaded: false,
        }
      }),
    }
  ),
  withHandlers({
    onSearchChange: ({ setFilters }) => (value) => {
      setFilters({ search: [{ key: 'trapName', value }] })
    },
    onTableSortClick: ({ setFilters }) => (orderBy) => {
      setFilters({ orderBy: [orderBy] })
    },
    onTableSelectableClick: ({ actions }) => (selectable, column) => {
      if (column.format === 'locate') {
        animateScroll.scrollTo(250, { duration: 500 })
        setTimeout(() => {
          actions.focusTrap(selectable)
        }, 500)
      }
    },
    onTableItemSelect: ({ 
      actions, organisation, group, filters, setPagination
    }) => (trap, column) => {
      if (column.format === 'locate') {
        animateScroll.scrollTo(250, { duration: 500 })
        setTimeout(() => {
          actions.focusTrap(trap)
        }, 500)
      } else {
        actions.removeTrapFromGroup(organisation, trap, () => {
          actions.showToast(toastModule.SUCCESS_TOAST, `${trap.trapName || 'This trap'} has successfully been removed from ${group.name}`)
          actions.getGroupTraps(organisation, group, filters, setPagination)
        })
      }
    }
  }),
  lifecycle({
    componentDidMount() {
      const {
        track, actions, organisation, group, filters, setPagination
      } = this.props

      track(SCREEN_VIEW_GROUP_TRAPS)
      actions.getGroupTraps(organisation, group, filters, setPagination)
    },
    componentDidUpdate(prevProps) {
      const {
        actions, organisation, group, filters, setPagination
      } = this.props

      if (!isEqual(filters, prevProps.filters) && !filters.loaded) {
        actions.getGroupTraps(organisation, group, filters, setPagination)
      }
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/groups/ManageGroupTraps/ManageGroupTraps.enhancer.js